export function truncate(s: string, maxLen: number, ellipsis = '…'): string {
  if (s.length <= maxLen) return s;
  if (maxLen <= ellipsis.length) return ellipsis.slice(0, maxLen);
  return s.slice(0, maxLen - ellipsis.length) + ellipsis;
}

export function truncateMiddle(s: string, maxLen: number, ellipsis = '…'): string {
  if (s.length <= maxLen) return s;
  if (maxLen <= ellipsis.length) return ellipsis.slice(0, maxLen);
  const charsToKeep = maxLen - ellipsis.length;
  const front = Math.ceil(charsToKeep / 2);
  const back = Math.floor(charsToKeep / 2);
  return s.slice(0, front) + ellipsis + s.slice(s.length - back);
}

export function pluralize(n: number, singular: string, plural?: string): string {
  return Math.abs(n) === 1 ? singular : (plural ?? singular + 's');
}

export function initials(name: string, max = 2): string {
  return name
    .trim()
    .split(/\s+/)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .filter(Boolean)
    .slice(0, max)
    .join('');
}
